import { render, staticRenderFns } from "./CmgHeaderActionsRight.vue?vue&type=template&id=2d326fb3&scoped=true&lang=pug&"
import script from "./cmg-header-actions-right.ts?vue&type=script&lang=ts&"
export * from "./cmg-header-actions-right.ts?vue&type=script&lang=ts&"
import style0 from "./CmgHeaderActionsRight.vue?vue&type=style&index=0&id=2d326fb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d326fb3",
  null
  
)

export default component.exports